module.exports = __webpack_public_path__ + "img/city (12).93a54144.png";